// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Avew","log":"ModalInventoryLogs_log__17rL_","date":"ModalInventoryLogs_date__1WwfI","userName":"ModalInventoryLogs_userName__3dLhX"};